// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__x7suh","title":"BackImages_title__30uCf","images":"BackImages_images__GkAf6"};